import Vue from 'vue';

const success = (context, response) => {
  toastr.success('Mis à jour avec succès');
};

const failed = (context, error) => {

};

export default (context, rentals) => {
  return Vue.$http.post(`superconciergerie/rentals`, {
    rentals: rentals ? rentals : context.rentals,
  })
    .then(response => {
      success(context, response.data);
    }).catch(error => {
      failed(context, error);
    })
}



// WEBPACK FOOTER //
// ./src/app/services/superconciergerie/update-rentals.js